import { useQuery } from 'react-query';

import { axios } from 'lib';

const getSupplierExclusions = (frameworkAgreementId, lotId, facId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/exclusions/suppliers/${facId}`
  );
};

export const useSupplierExclusions = (frameworkAgreementId, lotId, facId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-setup-lots-${lotId}-exclusion-suppliers-${facId}`,
    () => getSupplierExclusions(frameworkAgreementId, lotId, facId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
